module.exports = __webpack_public_path__ + "img/Front bumper.139a169c.jpg";